import $ from "jquery";
import ScrollMagic from "scrollmagic";

let controller = null;
let activeFn;
let animationScenes = [];

export function createController(_activeFn = null) {
    if (_activeFn === null) {
        _activeFn = scrollMagicActive;
    }

    if (controller !== null) {
        throw new Error("Tried to create multiple scroll magic controllers");
    }

    controller = new ScrollMagic.Controller();
    activeFn = _activeFn;

    $(window).on("resize", () => {
        updateControllerState(activeFn());
    });

    // Schedule an update once everything has been registered
    setTimeout(() => updateControllerState(activeFn()));

    return controller;
}

export function registerScene(scene) {
    if (controller === null) {
        createController();
    }

    scene.enabled(activeFn());

    scene.addTo(controller);
    animationScenes.push(scene);
}

function updateControllerState(enabled) {
    for (let scene of animationScenes) {
        scene.enabled(enabled);
    }

    if (!enabled) {
        for (let scene of animationScenes) {
            scene.update(true);
        }
    } else {
        $('.js-parallax-item').attr("style", "");
    }
}

export function scrollMagicActive() {
    return $(window).outerWidth() >= 960;
}

export function sectionGetHeight(el) {
    return $(el).outerHeight() * 2;
}
